var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare22E = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M53 21.765v1.764H43a2.219 2.219 0 0 1 2.349-2.215l7.651.45ZM53 38.236V36.47H43a2.219 2.219 0 0 0 2.349 2.215l7.651-.45ZM53 23.53v12.94H43V23.53z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M53 38.824V21.177"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20 22.5a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-15ZM6 35V25l8.274-.752A2.5 2.5 0 0 1 17 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 35Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 36-.445-.223A2.813 2.813 0 0 1 6 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 24"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.55 33h-1.125l2.048-5.818h1.301L26.825 33H25.7l-1.554-4.625h-.045L22.55 33Zm.037-2.281h3.068v.846h-3.068v-.846ZM29.803 33h-1.971v-5.818h2.011c.578 0 1.074.116 1.489.35.416.23.736.563.96.996.223.434.335.953.335 1.557 0 .606-.113 1.127-.338 1.563-.223.435-.546.77-.969 1.003-.42.232-.926.349-1.517.349Zm-.917-.912h.866c.405 0 .744-.074 1.014-.222.271-.15.475-.372.611-.667.137-.298.205-.669.205-1.114 0-.445-.069-.814-.205-1.108a1.394 1.394 0 0 0-.605-.662c-.265-.147-.595-.221-.989-.221h-.897v3.994Zm5.417.912h-1.125l2.049-5.818h1.3L38.58 33h-1.125L35.9 28.375h-.046L34.304 33Zm.037-2.281h3.068v.846H34.34v-.846Z"
})));
SvgSquare22E.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare22E);
export default ForwardRef;